import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ContractKpi from "./Kpi";
import ClaimsAgeing from "./ClaimsAgeing";
import ClaimsStatus from "./ClaimsStatus";
import ClaimsValue from "./ClaimsValue";
import Claims from "./Claims";
import ChangeOrder from "./ChangeOrder";
import ChangeOrderAgeing from "./ChangeOrderAgeing";
import ChangeOrderStatus from "./ChangeOrderStatus";
import ChangeOrderValue from "./ChangeOrderValue";

export const claimRaisedOptions = [
  { value: "Claim Order Received", label: "Claim Order Received" },
  { value: "Claim Order Raised", label: "Claim Order Raised" },

];

const ClaimsRaised = (props) => {

  const { tabValue } = props

  const RaisedType = claimRaisedOptions[tabValue]?.value

  return (
    <>
      <Grid container spacing={"10px"} sx={{ p: 0, pb: 6 }}>
        <Grid container columnSpacing={1.5} rowSpacing={1.5} sx={{ px: 2 }}>
          <Grid size={{ xs: 12, md: 12 }}>
            <ContractKpi RaisedType={RaisedType} />
          </Grid>

          <Grid
            size={{ sx: 12, md: 6 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                //height: "100%",
              }}
            >
              <Claims RaisedType={RaisedType} />
            </Box>
          </Grid>
          <Grid
            size={{ sx: 12, md: 6 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                //height: "100%",
              }}
            >
              <ChangeOrder RaisedType={RaisedType} />
            </Box>
          </Grid>
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ClaimsAgeing RaisedType={RaisedType} />
            </Box>
          </Grid>
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ChangeOrderAgeing RaisedType={RaisedType} />
            </Box>
          </Grid>
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ClaimsStatus RaisedType={RaisedType} />
            </Box>
          </Grid>
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ChangeOrderStatus RaisedType={RaisedType} />
            </Box>
          </Grid>

          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ClaimsValue RaisedType={RaisedType} />
            </Box>
          </Grid>
          <Grid size={{ sx: 12, md: 6 }}>
            <Box
              sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 0,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
                overflow: "hidden",
                height: "100%",
              }}
            >
              <ChangeOrderValue RaisedType={RaisedType} />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ClaimsRaised;
